import { Navigate, useSearchParams } from 'react-router';
import { useStudio } from '@/features/studio/studio-data';

/**
 * /s/<slug>/assistant keeps working as a link (shared, bookmarked, from a shell):
 * it opens the studio home with the assistant sheet, passing a question along.
 */
export function AssistantPage() {
  const studio = useStudio();
  const [params] = useSearchParams();
  const search = new URLSearchParams({ ask: '1' });
  const q = params.get('q');
  if (q) search.set('q', q);
  return <Navigate to={{ pathname: `/s/${studio.slug}/`, search: search.toString() }} replace />;
}
